import { BLAZE_EVENTS } from "@swiggy-private/checkout-core";
import Blaze from "@swiggy-private/blaze.js";
import { RECORD_PERCIEVED_TIME_EVENTS } from "@cart-client/constants/index";
import { Storage } from "@swiggy-private/core-ui";

export const recordCartPercievedTime = (): void => {
    const isSessionStorageAvailable = typeof window !== "undefined" && typeof sessionStorage !== "undefined";

    // Record load time metric for single instance in session,
    // to prevent falsy metrics be populated which navigating back from history (payments => cart)
    if (isSessionStorageAvailable && sessionStorage.getItem("hasCartLoadTimeRecorded") !== "true") {
        Blaze.recordTimeFromAppStart(RECORD_PERCIEVED_TIME_EVENTS.CART_LOAD_EVENT);
        sessionStorage.setItem("hasCartLoadTimeRecorded", "true");
    }

    Blaze.recordEnd(BLAZE_EVENTS.RECORD_CART_LOAD_TIME);

    // TO BE DEPERECATED IN FAVOR OF BLAZE.JS
    // if performance API is not supported for old browser dont capture records
    if (!performance?.timeOrigin) {
        return;
    }
};

export const recordSharedCartPerceivedTime = (): void => {
    // Record load time metric for single instance in session,
    // to prevent falsy metrics be populated which navigating back from history (payments => cart)
    if (Storage.getItem("hasGroupCartLoadTimeRecorded") !== "true") {
        Blaze.recordTimeFromAppStart(RECORD_PERCIEVED_TIME_EVENTS.GROUP_CART_LOAD_EVENT);
        Storage.setItem("hasGroupCartLoadTimeRecorded", "true");
    }

    Blaze.recordEnd(BLAZE_EVENTS.RECORD_INTERMEDIATE_SHARED_CART_SCREEN_LOAD_TIME);

    // TO BE DEPERECATED IN FAVOR OF BLAZE.JS
    // if performance API is not supported for old browser dont capture records
    if (!performance?.timeOrigin) {
        return;
    }
};
